/* =========================================================================
   MARKETING Hero — Second Opinion: shared types & schema.
   The AI must NOT rubber-stamp the user's plan. It restates the plan, checks
   data, challenges assumptions, then takes an explicit stance with reasons.
   ========================================================================= */

export type Stance = "agree" | "partially_agree" | "disagree" | "need_data" | "test_first";

export const STANCE_META: Record<Stance, { label: string; pill: string }> = {
  agree: { label: "เห็นด้วย (Agree)", pill: "mh-pill--winner" },
  partially_agree: { label: "เห็นด้วยบางส่วน (Partially Agree)", pill: "mh-pill--watch" },
  disagree: { label: "ไม่เห็นด้วย (Disagree)", pill: "mh-pill--problem" },
  need_data: { label: "ต้องการข้อมูลเพิ่ม (Need More Data)", pill: "mh-pill--neutral" },
  test_first: { label: "ควรทดสอบก่อน (Test Before Decision)", pill: "mh-pill--testing" },
};

export interface SecondOpinionOutput {
  understanding: string;
  stance: Stance;
  stanceLabel: string;
  dataCheck: string;
  challengedAssumptions: string[];
  reason: string;
  risk: string;
  alternative: string;
  recommendedDecision: string;
  confidence: "high" | "medium" | "low";
}

export const OPINION_SCHEMA_HINT = {
  understanding: "string — ทวนแผนของผู้ใช้ด้วยคำของคุณ",
  stance: "agree|partially_agree|disagree|need_data|test_first",
  stanceLabel: "string",
  dataCheck: "string — ข้อมูลพอตัดสินใจไหม",
  challengedAssumptions: ["string — สมมติฐานที่ควรตั้งคำถาม"],
  reason: "string",
  risk: "string",
  alternative: "string",
  recommendedDecision: "string",
  confidence: "high|medium|low",
};
